import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Select, Icon, Button } from 'antd';
import debounce from 'lodash.debounce';
import routes from 'src/routes';
import ConfirmationDownloadCentered from 'src/components/common/ConfirmationDownloadCentered';
import { useMonitoredSegments } from '../../hooks/useMonitoredSegments';

import styles from './MonitoredSegments.module.less';

const { Option } = Select;

type PropsMonitoredSegments = {
  segmentIds: number[];
  setSegmentIds: (segmentIds: number[]) => void;
};

const warningMessage =
  'Warning: Any data you have entered will be lost if you proceed to create a new segment. Are you sure you want to continue?';

export const MonitoredSegments: React.FC<PropsMonitoredSegments> = ({ segmentIds, setSegmentIds }) => {
  const history = useHistory();
  const { segmentList, setSegmentName } = useMonitoredSegments({ segmentIds });
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);

  const setMonitoredSegments = (ids: string[]) => {
    // TODO: it's will be change after update API
    const allSegmentIds = segmentList.map((s) => s.productSegmentId).map(String);
    const allSelectedIdsExist = ids.every((id) => allSegmentIds.includes(id));

    if (allSelectedIdsExist || ids.length === 0) {
      setSegmentIds(ids.map(Number));
    }
  };
  const setSearch = useCallback(debounce(setSegmentName, 500), []);

  const getSelectedSegments = (): string[] => {
    return segmentIds.map(String);
  };

  return (
    <>
      <Select
        mode="tags"
        onSearch={setSearch}
        value={getSelectedSegments()}
        onChange={setMonitoredSegments}
        tokenSeparators={[',']}
        filterOption={false}
        autoClearSearchValue={false}
        onFocus={() => setSearch('')}
        maxTagCount={1}
        dropdownRender={(menu) => {
          return (
            <>
              <Button
                type="primary"
                size="small"
                className={styles.btn}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  setShowConfirmModal(true);
                }}
              >
                <Icon type="plus" /> Create New Segment
              </Button>
              {menu}
            </>
          );
        }}
      >
        {segmentList.map((el) => {
          return <Option key={el.productSegmentId}>{el.productSegmentName}</Option>;
        })}
      </Select>
      <ConfirmationDownloadCentered
        title={'Confirm New Segment Creation'}
        name={''}
        confirmationVisible={showConfirmModal}
        onAction={() => history.push(`${routes.productAlerts}/segmentConfig/new`)}
        setVisible={() => setShowConfirmModal(false)}
        message={warningMessage}
      />
    </>
  );
};
